<template>
<div class="page page_xiaofei page_income">
    <div class="top">
        <div class="txt">总积分:<span class="cash">{{ score }}</span></div>
    </div>
	<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
		<div class="list">
			<div class="item" v-for="(item,index) in dataList" :key="index">
				<img :src="item.tradesman_thumb ? ($publicData.withHttpStart(item.tradesman_thumb) ? item.tradesman_thumb :imageUrl+item.tradesman_thumb ) : $publicData.defaultTouxiang" alt="" class="thumb">
				<div class="item_r">
					<div class="item_nr">
						<div class="title slh_s">{{ item.tradesman_name }}</div>
						<div class="time">{{ item.pay_order_num }}</div>
					</div>
					<div class="price"><span class="tag_cash">{{ item.type == 1 ? '+' : '-'}}¥</span>{{ item.score }}</div>
				</div>
			</div>
		</div>
	</van-list>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
			token: null,
			park_uuid: this.$route.query.park_uuid,
			loading: false,
			finished: false,
			pages: {
				page: 1,
				size: 10
			},
			dataList: [],
			score: this.$route.query.score
        };
    },
    components: {
        PageSearch
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '积分记录'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
					this.token = data.result.token
					this.getData()
                } else {
                    this.token = ''
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
			this.token = this.$store.getters.token
			this.getData()
        }
    },
    methods: {
		// 获取积分
		getData(){
			var params = {
				token: this.token,
				park_uuid: this.park_uuid,
                page: this.pages.page,
                size: this.pages.size
			}
			this.$api.park.parkScore(params).then(res=>{
				if(res.code == 200){
					var list = []
					list = res.result.list
					if(list.length != 0){
						for(var i in list){
							this.dataList.push(list[i])
						}
					}else{
						this.finished = true
					}
				}else{
					this.finished = true
				}
				this.pages.page++
				this.loading = false
			})
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
